const cropsFinder = {
  selectCategory: Drupal.t('Select a category:'),
  selectCrop: Drupal.t('Select a crop:'),
};

export default cropsFinder;
